import { connect, type ConnectedProps } from 'react-redux';

import { selectNewPrice } from 'src/routes/Checkout/store/selectors/price';
import { getPackageId } from 'src/routes/Checkout/store/selectors/package';
import { getIsWishlistAvailable } from 'src/store/menu/selectors';
import { getIsHotelOnly } from 'src/store/view/selectors';

import { getPath } from '../../../../store/selectors/router';

import Header from './Header';

const mapStateToProps = (state) => ({
  price: selectNewPrice(state),
  path: getPath(state),
  isHotelOnly: getIsHotelOnly(state),
  packageId: getPackageId(state),
  isWishlistAvailable: getIsWishlistAvailable(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Header);
